import http from '@/app/services/httpServices';
import URL_UTILITY from '../../app/utility/url.utility';

const uploadInvoiceLoader = (context, payload) => {
  return http.postApi(
    URL_UTILITY.getValueSetUrl +
      `/vendor-excel-upload/${payload.import_header_id}/excel-upload`
  );
};
const getInvLoaderDtls = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getValueSetUrl + '/vendor-excel-upload/data',
    payload
  );
};
const getInvLoaderDtlsById = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getValueSetUrl + '/vendor-excel-upload/' + payload.hdrId
  );
};
const getSplitDtlsForCostCenter = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getValueSetUrl +
      '/vendor-excel-upload/cost-center/' +
      payload.vendorInvDtlId
  );
};
const getSplitDtlsForDistribution = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getValueSetUrl +
      '/vendor-excel-upload/distribution-data/' +
      payload.vendorInvDtlId
  );
};
export default {
  uploadInvoiceLoader,
  getInvLoaderDtls,
  getInvLoaderDtlsById,
  getSplitDtlsForCostCenter,
  getSplitDtlsForDistribution
};
